module.exports = __webpack_public_path__ + "img/3.cad8f0fe.jpg";